import React, { useRef, useState } from 'react'
import style from './style.css'

function Additionals(props) {

    let addc = props.additionals.trim();
    if (addc.length === 0) {
        addc = [];
    } else {
    addc = JSON.parse(addc);
    // Restante do código aqui
    }

    
    
    

    return (
        <div>
        {Object.entries(addc).map(([key, value]) => (
            value != '' ?  <li className={style.li} key={key}>{key} : <b>{value}</b></li> : ''
            
            
          
        ))}
      </div>
    )
}

export default Additionals


// WEBPACK FOOTER //
// ./src/App/Components/Add/index.js